var map = {
	"./de.json": [
		23634,
		"src_assets_i18n_de_json"
	],
	"./en.json": [
		40502,
		"src_assets_i18n_en_json"
	],
	"./es.json": [
		84268,
		"src_assets_i18n_es_json"
	],
	"./fr.json": [
		71463,
		"src_assets_i18n_fr_json"
	],
	"./pt.json": [
		5733,
		"src_assets_i18n_pt_json"
	],
	"./sw.json": [
		8939,
		"src_assets_i18n_sw_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16297;
module.exports = webpackAsyncContext;